import { alpha, styled } from "@mui/material/styles";
import Popover from "@mui/material/Popover";
import { FormControl, Button } from "@mui/material";
import React from "react";
import DeleteOutlineSharpIcon from "@mui/icons-material/DeleteOutlineSharp";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import config from "../../hoa-config";
import datastore from "../../store/hoa-datastore";

const InputTextField = styled(TextField)(({ theme, error }) => ({
    "& .MuiFilledInput-root": {
        border: !error ? "1px solid #e2e2e1" : "1px solid #FF0000",
        overflow: "hidden",
        borderRadius: 4,
        backgroundColor: theme.palette.mode === "light" ? "#fcfcfb" : "#2b2b2b",
        transition: theme.transitions.create(["border-color", "background-color", "box-shadow"]),
        "&:hover": {
            backgroundColor: "transparent",
        },
        "&.Mui-focused": {
            backgroundColor: "transparent",
            boxShadow: `${alpha(theme.palette.primary.main, 0.25)} 0 0 0 2px`,
            borderColor: "#0000ff",
        },
    },
}));

const sourceType = ["All", "Mail", "Email"];

export default function PendingSourceAdvanceFiltering(props: any) {
    const { anchorEl, setAnchorEl, onChangeText, onMoreFilterClick, options, tagType } = props;

    return (
        <Popover
            open={anchorEl ? true : false}
            anchorEl={anchorEl}
            onClose={() => onMoreFilterClick("Cancel")}
            anchorOrigin={{
                vertical: "bottom",
                horizontal: "right",
            }}
            transformOrigin={{
                vertical: "top",
                horizontal: "right",
            }}
            PaperProps={{
                elevation: 0,
                style: {
                    marginTop: "10px",
                    width: "589px",
                    maxHeight: "520px",
                    filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                    background: "#FFFFFF",
                    border: "1px solid #E8E8E8",
                    boxShadow: "0px 10px 26px rgba(0, 0, 0, 0.2)",
                    borderRadius: "8px",
                },
            }}
        >
            <main
                style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexDirection: "column",
                }}
            >
                <div
                    style={{
                        width: "calc(100% - 48px)",
                        borderBottom: "1px solid  #F7F7F7",
                        marginTop: "24px",
                    }}
                >
                    <div className={"advance-filter-container"}>
                        <span
                            className="filter-field-title-comp"
                            style={{ margin: "2px", width: "85px", wordBreak: "break-all" }}
                        >{`ID`}</span>
                        <InputTextField
                            style={{ width: "184px", margin: "2px", marginLeft: "40px" }}
                            label={`ID`}
                            InputProps={{ disableUnderline: true }}
                            variant="filled"
                            value={options.entityId || ""}
                            name="entityId"
                            onChange={onChangeText}
                        />
                        {/* Organization filter */}
                        <FormControl>
                            <Autocomplete
                                ListboxProps={{ style: { maxHeight: "200px" } }}
                                style={{
                                    width: "184px",
                                    margin: "2px",
                                    marginLeft: "38px",
                                }}
                                disableClearable
                                disablePortal
                                value={
                                    config.hoaOrganizations.find(
                                        (org: any) => org.id === options.organizationId
                                    ) || null
                                }
                                options={config.hoaOrganizations}
                                getOptionLabel={(option) => option.name}
                                isOptionEqualToValue={(option, value) => option.id === value.id}
                                onChange={(e, v) => {
                                    if (v !== null) {
                                        onChangeText({
                                            target: {
                                                name: "organizationId",
                                                value: v.id,
                                            },
                                        });
                                    }
                                }}
                                renderInput={(params: any) => (
                                    <TextField
                                        {...params}
                                        label="Organization Name"
                                        name="organizationId"
                                    />
                                )}
                            />
                        </FormControl>
                    </div>
                    <div className="advance-filter-container">
                        <span
                            className="filter-field-title-comp"
                            style={{
                                margin: "2px",
                                width: "85px",
                                wordBreak: "break-all",
                            }}
                        >{`Source Type`}</span>
                        {/* Source type filter */}
                        <FormControl>
                            <Autocomplete
                                ListboxProps={{ style: { maxHeight: "200px" } }}
                                style={{
                                    width: "184px",
                                    margin: "2px",
                                    marginLeft: "38px",
                                }}
                                disableClearable
                                disablePortal
                                value={
                                    sourceType.find(
                                        (each: string) => each === options.sourceType
                                    ) || null
                                }
                                options={sourceType}
                                onChange={(e, v) => {
                                    if (v !== null) {
                                        onChangeText({
                                            target: {
                                                name: "sourceType",
                                                value: v,
                                            },
                                        });
                                    }
                                }}
                                renderInput={(params: any) => (
                                    <TextField {...params} label="Source Type" name="sourceType" />
                                )}
                            />
                        </FormControl>
                        <InputTextField
                            style={{ width: "184px", margin: "2px", marginLeft: "40px" }}
                            label={`Folder Name`}
                            InputProps={{ disableUnderline: true }}
                            variant="filled"
                            value={options.folderName || ""}
                            name="folderName"
                            onChange={onChangeText}
                        />
                    </div>
                </div>

                <div className="filter-footer">
                    <Button
                        onClick={() => onMoreFilterClick("Clear")}
                        startIcon={<DeleteOutlineSharpIcon style={{ color: "#3576E5" }} />}
                        id="clear-all-btn"
                    >
                        <span id="btn-title">Clear All</span>
                    </Button>
                    <div>
                        <Button onClick={() => onMoreFilterClick("Cancel")} id="cancel-btn">
                            <span id="btn-title">Cancel</span>
                        </Button>
                        <Button
                            onClick={() => onMoreFilterClick("Apply")}
                            variant="contained"
                            id="apply-btn"
                        >
                            <span style={{ color: "white" }} id="btn-title">
                                Apply Filter
                            </span>
                        </Button>
                    </div>
                </div>
            </main>
        </Popover>
    );
}
